import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/control-centre-logo-full.svg'
import _imports_1 from '@/core/assets/icons/icon-options.svg'
import _imports_2 from '@/core/assets/icons/icon-white-profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-31b4d688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "wonderkind" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "options",
  class: "options"
}, null, -1))
const _hoisted_5 = { class: "navbar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "company",
    class: "icon"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Profiles")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_options_drop_down = _resolveComponent("options-drop-down")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo-opacity"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_options_drop_down, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("nav", null, [
        _createVNode(_component_router_link, { to: "/profiles" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}